export const PASSWORD_RULE =
  /^(?:(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*['!@#$%^&*()\-_/+=;&`´~çàèé,.?":{}|<>\s\\])(?=.{8,}).*)$/;
